import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styles from './PieChart.module.scss';
var PieChart = function (_a) {
    var size = _a.size, width = _a.width, percent = _a.percent, className = _a.className, id = _a.id, dataId = _a.dataId;
    var PieStyle = {
        '--s': "".concat(size, "px"),
        '--w': "".concat(width, "px"),
        '--p': percent,
    };
    return (_jsx("div", { id: id, className: "".concat(styles.PieChart, " ").concat(className ? className : ''), "data-testid": dataId, style: PieStyle }));
};
PieChart.propTypes = {
    size: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
    className: PropTypes.string,
    id: PropTypes.string,
    dataId: PropTypes.string,
};
export { PieChart };
//# sourceMappingURL=PieChart.js.map